import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetUserInboxes as GetUserInboxesQuery,
    GetUserInboxesVariables as GetUserInboxesQueryVariables,
} from 'nutshell-graphql-types';

import GET_USER_INBOXES from '../queries/get-user-inboxes.graphql';

export const useGetUserInboxes = () => {
    const {
        data: chatData,
        error: chatError,
        loading: isChatLoading,
    } = useQuery<GetUserInboxesQuery, GetUserInboxesQueryVariables>(GET_USER_INBOXES, {
        variables: {threadType: 'CHAT'},
    });

    const {
        data: smsData,
        error: smsError,
        loading: isSmsLoading,
    } = useQuery<GetUserInboxesQuery, GetUserInboxesQueryVariables>(GET_USER_INBOXES, {
        variables: {threadType: 'SMS'},
    });

    const {
        data: messengerData,
        error: messengerError,
        loading: isMessengerLoading,
    } = useQuery<GetUserInboxesQuery, GetUserInboxesQueryVariables>(GET_USER_INBOXES, {
        variables: {threadType: 'MESSENGER'},
    });

    const {
        data: allChannelsData,
        error: allChannelsError,
        loading: isAllChannelsLoading,
    } = useQuery<GetUserInboxesQuery, GetUserInboxesQueryVariables>(GET_USER_INBOXES, {
        variables: {threadType: null},
    });

    const {
        data: instagramData,
        error: instagramError,
        loading: isInstagramLoading,
    } = useQuery<GetUserInboxesQuery, GetUserInboxesQueryVariables>(GET_USER_INBOXES, {
        variables: {threadType: 'INSTAGRAM'},
    });

    const {
        data: whatsAppData,
        error: whatsAppError,
        loading: isWhatsAppLoading,
    } = useQuery<GetUserInboxesQuery, GetUserInboxesQueryVariables>(GET_USER_INBOXES, {
        variables: {threadType: 'WHATSAPP'},
    });

    const {
        data: emailData,
        error: emailError,
        loading: isEmailLoading,
    } = useQuery<GetUserInboxesQuery, GetUserInboxesQueryVariables>(GET_USER_INBOXES, {
        variables: {threadType: 'EMAIL'},
    });

    const chatUserInboxes = chatData ? chatData.userInboxes : [];
    const smsUserInboxes = smsData ? smsData.userInboxes : [];
    const messengerUserInboxes = messengerData ? messengerData.userInboxes : [];
    const instagramUserInboxes = instagramData ? instagramData.userInboxes : [];
    const allChannelsUserInboxes = allChannelsData ? allChannelsData.userInboxes : [];
    const whatsAppUserInboxes = whatsAppData ? whatsAppData.userInboxes : [];
    const emailUserInboxes = emailData ? emailData.userInboxes : [];

    return {
        chatUserInboxes,
        smsUserInboxes,
        messengerUserInboxes,
        instagramUserInboxes,
        whatsAppUserInboxes,
        emailUserInboxes,
        allChannelsUserInboxes,
        error: safelyGetGraphQLErrorMessage(
            // @ts-expect-error
            chatError ||
                smsError ||
                messengerError ||
                allChannelsError ||
                instagramError ||
                whatsAppError ||
                emailError
        ),
        isLoading:
            isChatLoading ||
            isSmsLoading ||
            isMessengerLoading ||
            isAllChannelsLoading ||
            isInstagramLoading ||
            isWhatsAppLoading ||
            isEmailLoading,
    };
};
